import { render, staticRenderFns } from "./CustomerBillTable.vue?vue&type=template&id=bdb9bc86"
import script from "./CustomerBillTable.vue?vue&type=script&lang=js"
export * from "./CustomerBillTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports